"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CompleteEnquiryTimeout;
require("core-js/modules/es.function.name.js");
function CompleteEnquiryTimeout(data) {
  this.name = 'BunnyPublisherTimeoutException';
  this.data = data;
  this.message = JSON.stringify(data);
  this.stack = new Error().stack;
}
CompleteEnquiryTimeout.constructor = CompleteEnquiryTimeout;